import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomButton from "./CustomButton";
import { Close } from "@mui/icons-material";
import CustomIconButton from "./CustomIconButton";
import NullCheck from "./NullCheck";
import CustomTabs from "./CustomTabs";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect } from "react";

const CustomDialog = ({
  open,
  onClose,
  children,
  title,
  width,
  actionBtn,
  closeBtn,
  extraBtn1,
  textFotter,
  fullScreen,
  maxWidth,
  contentPadding,
  contentSx,
  actionsPadding,
  tabs,
  minWidth,
  minHeight,
  maxHeight,
  height,
  tabsActions,
}) => {
  const theme = useTheme()
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  useEffect(() => {
    const handlePopState = (e) => {
      if (open) {
        e.preventDefault();
        onClose();
      }
    };

    if (open) {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", handlePopState);
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [open, onClose]);

  const handleDialogClose = (event, reason) => {
    if (reason === "escapeKeyDown") onClose();
  }

  const dialogTabs = <CustomTabs
    tabList={tabs?.list ?? []}
    scrollAmount={20}
    showScrollBtn={tabs?.showScrollBtn ?? false}
    sticky={tabs?.sticky ?? false}
    divider={tabs?.divider ?? false}
    defaultValue={tabs?.defaultValue ?? 0}
    variant={tabs?.variant}
    sx={tabs?.sx}
    callBackFunc={(e) => tabs?.callBackFunc ? tabs.callBackFunc(e) : null}
  />;

  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: fullScreen && height ? '100%' : isMobile ? '95%' : width ?? "auto",
          minWidth: fullScreen && height ? '100%' : isMobile ? '95%' : minWidth ?? "auto",
          maxWidth: fullScreen && height ? '100%' : isMobile ? '95%' : maxWidth ?? "auto",
          ...(height !== undefined ? { height } : {}),
          minHeight: minHeight ?? "auto",
          maxHeight: maxHeight ?? 600,
          borderRadius: fullScreen && height ? 0 : 3,
          bgcolor: "bgPage.main",
        },
        "& .MuiBackdrop-root": {
          bgcolor: "rgba(0 , 0, 0, 0.5)",
          backdropFilter: "blur(2px)",
        },
      }}
      open={open}
      onClose={handleDialogClose}
      fullScreen={fullScreen}
    >
      <DialogTitle sx={{ padding: 0, ...(height ? { flexShrink: 0 } : {}) }}>
        <Stack
          padding={1.5}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={5}
        >
          <Typography variant="h6">{bt(title)}</Typography>

          <Stack direction='row' spacing={2}>
            <CustomIconButton
              hideBgcolor
              iconColor="primary.text"
              size={30}
              icon={<Close />}
              onClick={onClose ? onClose : null}
            />
          </Stack>
        </Stack>

        <NullCheck valueForCheck={tabs}>
          {tabsActions ? <Stack direction="row" alignItems="flex-end" gap={{ xs: 0.5, sm: 2 }} sx={{ px: { xs: 1, sm: 2 }, minWidth: 0 }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>{dialogTabs}</Box>
            <Box sx={{ flexShrink: 0, pb: 1 }}>{tabsActions}</Box>
          </Stack> : dialogTabs}
        </NullCheck>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: contentPadding ?? 2,
          maxHeight: height ? 'none' : '70vh',
          overflowY: 'auto',
          ...(height ? { flex: 1, minHeight: 0, overflowX: 'hidden' } : {}),
          ...contentSx,
        }}
        dividers

      >
        {children}
      </DialogContent>

      <NullCheck valueForCheck={closeBtn || extraBtn1 || actionBtn || textFotter}>
        <DialogActions sx={{ padding: actionsPadding ?? 2, ...(height ? { flexShrink: 0 } : {}) }} >
          <Stack width='100%' spacing={2}>

            <NullCheck valueForCheck={closeBtn || extraBtn1 || actionBtn}>
              <Stack direction='row' justifyContent='end' alignItems='center' spacing={2}>
                <NullCheck valueForCheck={closeBtn && onClose}>
                  <CustomButton
                    title={bt(closeBtn)}
                    fullWidth
                    height={45}
                    color="error.main"
                    textColor="error.text"
                    onClick={() => onClose ? onClose() : null}
                  />
                </NullCheck>

                <NullCheck valueForCheck={extraBtn1}>
                  <CustomButton
                    title={bt(extraBtn1?.title)}
                    fullWidth
                    height={45}
                    color={extraBtn1?.color ?? "primary"}
                    onClick={() => extraBtn1?.onClick()}
                  />
                </NullCheck>

                <NullCheck valueForCheck={actionBtn}>
                  <CustomButton
                    title={bt(actionBtn?.title)}
                    autoFocus
                    fullWidth
                    height={45}
                    color={actionBtn?.color ?? "success.main"}
                    textColor={actionBtn?.Textcolor ?? "success.text"}
                    disabled={actionBtn?.disabled}
                    onClick={() => actionBtn?.onClick()}
                  />
                </NullCheck>
              </Stack>
            </NullCheck>

            <NullCheck valueForCheck={textFotter}>
              <Stack width='100%' alignItems='center' justifyContent='center'>
                <Typography>{textFotter}</Typography>
              </Stack>
            </NullCheck>

          </Stack>
        </DialogActions>
      </NullCheck>
    </Dialog>
  );
};
export default CustomDialog;
